module.exports = __webpack_public_path__ + "static/shifting-gears-to-drive-91dbcd6e784b7328b4acf845b8ed89c2.jpg";